import React from 'react';
import { createRoot } from 'react-dom/client';
import '@/styles/global.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';

const root = createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);

navigator?.serviceWorker?.getRegistrations()?.then((registrations) => {
    if (registrations == null) return;

    for (const registration of registrations) {
        if (registration?.scope.includes('media.fifa.com')) {
            registration?.unregister();
        }
    }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
